import React from 'react';
import Image from 'next/image';
import styles from './Checkbox.module.scss';
import assetLoader from "@utils/internalImageLoder";

interface CheckboxProps {
  label: string;
  checked: boolean;
  onChange: () => void;
  className?: string;
  indeterminate?: boolean;
}

const Checkbox: React.FC<CheckboxProps> = ({
  label,
  checked,
  onChange,
  className,
  indeterminate = false
}) => {
  const isActive = checked || indeterminate;

  return (
    <label className={`${styles.container} ${className}`}>
      <div className={styles.checkboxWrapper}>
        <input
          type="checkbox"
          checked={checked}
          onChange={onChange}
          className={styles.input}
          aria-checked={indeterminate ? 'mixed' : checked}
        />
        <div className={`${styles.checkbox} ${isActive ? styles.checked : ''}`}>
          {isActive && (
            <Image
              src={`${assetLoader()}/icons/${indeterminate ? 'minusIcon.webp' : 'tick-light.svg'}`}
              alt={indeterminate ? 'Partially selected' : 'Checked'}
              width={indeterminate ? 10 : 11}
              height={indeterminate ? 3 : 8}
            />
          )}
        </div>
      </div>
      <span className={styles.label}>{label}</span>
    </label>
  );
};

export default Checkbox; 
